import React from 'react'
import {config} from '../config'
const txdomain = config()['tourneyx-url']


const Register = ({ tournamentDetails,user_information} )=> {
 
  //console.log('tournamentid passed:: ',tournamentId );
  //console.log('cutoff_date passed::',cuttoff_date );
  //console.log('tournament end_date passed::',end_date );
 
  var showRegistration = true;
  //console.log('Converted cutoff date value :::',  new Date(cuttoff_date));

  // Change added on 03-11-2021
  showRegistration = ( tournamentDetails.cuttoff_date != null &&  new Date() > new Date(tournamentDetails.cuttoff_date.replace(/-/g, "/")) ) ? false: true;

  if( ( new Date() > new Date(tournamentDetails.end_date.replace(/-/g, "/")) ) || ( user_information && user_information.role !== '3')  ){

    //console.log('Inside if condition for current date GREATER than tournament END DATE OR logged in user role is NOT 3 ');
    showRegistration = false;
  
  }

  //console.log('Is user already registered for the tournament check :: ',tournamentDetails.anglers.indexOf(user_information && user_information.user_id) > -1);

  if( (tournamentDetails.anglers && tournamentDetails.anglers.length > 0 ) &&  ( (tournamentDetails.anglers.indexOf( user_information && user_information.user_id) > -1) == true )  ) {
    showRegistration = false;
  }

  // Additional limit check added to not allow extra anglers register for tournament
  if( (tournamentDetails.angler_limit && tournamentDetails.angler_limit != 0 && tournamentDetails.anglers && tournamentDetails.anglers.length >= tournamentDetails.angler_limit )   ){
    showRegistration = false;
  }
  console.log('showRegistration flag value :::',  showRegistration);

  return (
    <>
    {
      
      showRegistration 
      ? <a href={`${txdomain}/app/dashboard/tourney-registration/${tournamentDetails.id}`} className='right-btn'> Register For Tourney </a> 
      : null

    }

    </>
  )

} 

export default Register